import { PropTypes } from "prop-types";

import TrialButton from "@/components/TrialButton";

const propTypes = {
  css: PropTypes.string,
  className: PropTypes.string,
};

const StartTrialCta = ({ css, className }) => (
  <div css={css} className={className}>
    <TrialButton />
  </div>
);

StartTrialCta.propTypes = propTypes;
export default StartTrialCta;
